import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'
import { prepareSearchParams } from '@/libs/helper'

const resource = `${Config.basePath}/service-system`

export default {
  index(payload) {
    return Client.get(`${resource}/list`, {
      params: prepareSearchParams(payload, 10),
    })
  },
  show(id) {
    return Client.get(`${resource}/${id}`)
  },
  exportExcel(payload) {
    return Client.get(`${resource}/download`, {
      params: payload,
    })
  },
  logs(payload, id) {
    return Client.get(`${resource}-logs/${id}`, {
      params: prepareSearchParams(payload, 100),
    })
  },
  log(id) {
    return Client.get(`${resource}-logs/log/${id}`)
  },
  assignOperator: (payload, id) => Client.put(`${resource}/assign/${id}`, payload),
  updateStatus: (payload, id) => Client.put(`${resource}/update/${id}`, payload),
  getUnseenCount: () => Client.get(`${resource}/unseen`),
  markSeenServiceTicket: id => Client.put(`${resource}/seen/update/${id}`),
  handover: payload => Client.put(`${resource}/handover`, payload),
  handoverServices: payload => Client.get(`${resource}/handover`, {
    params: payload,
  }),
  getServiceType: payload => Client.get(`${resource}/type`, {
    params: prepareSearchParams(payload),
  }),
  getServiceCategory: payload => Client.get(`${resource}/category`, {
    params: prepareSearchParams(payload),
  }),
  createCategory: payload => Client.post(`${resource}/category`, payload),
  updateCategory: (id, payload) => Client.put(`${resource}/category/${id}`, payload),
  deleteCategory: id => Client.delete(`${resource}/category/${id}`),
  createServiceType: payload => Client.post(`${resource}/type`, payload),
  updateServiceType: (id, payload) => Client.put(`${resource}/type/${id}`, payload),
  deleteServiceType: id => Client.delete(`${resource}/type/${id}`),
  getServiceSubType: payload => Client.get(`${resource}/subtype`, {
    params: prepareSearchParams(payload),
  }),
  createServiceSubType: payload => Client.post(`${resource}/subtype`, payload),
  updateServiceSubType: (id, payload) => Client.put(`${resource}/subtype/${id}`, payload),
  deleteServiceSubType: id => Client.delete(`${resource}/subtype/${id}`),
  // options for service type
  options: payload => Client.get(`${resource}/type`, {
    params: prepareSearchParams(payload),
  }),
  createService: payload => Client.post(`${resource}/create`, payload),
  createServicePanel: payload => Client.post(`${resource}/create/service-panel`, payload),
  getEachBadgeCount: () => Client.get(`${resource}/unseen/by/status`),
  getOverviewSummary: payload => Client.get(`${resource}/overview/summary`, {
    params: prepareSearchParams(payload, 25),
  }),
  getPendingOrders: payload => Client.get(`${resource}/overview/pending-order`, {
    params: prepareSearchParams(payload, 5),
  }),
  getOrderData: payload => Client.get(`${resource}/overview/order-data`, {
    params: prepareSearchParams(payload, 10),
  }),
  getDailyOrders: payload => Client.get(`${resource}/overview/daily-order`, {
    params: prepareSearchParams(payload, 10),
  }),
  getOperatorRanking: payload => Client.get(`${resource}/overview/operator-ranking`, {
    params: prepareSearchParams(payload, 10),
  }),
  getVoiceSetting: () => Client.get(`${resource}/voice-setting`),
  updateVoiceSetting: (id, payload) => Client.put(`${resource}/voice-setting/${id}`, payload),
  addOthers: payload => Client.post(`${Config.basePath}/service-system-helper`, payload),
  getHelpers: payload => Client.get(`${Config.basePath}/service-system-helper`, {
    params: {
      serviceSystemId: payload.serviceSystemId,
    },
  }),
  updateHelperStatus: (payload, id) => Client.put(`${Config.basePath}/service-system-helper/${id}`, payload),
  deleteHelper: id => Client.delete(`${Config.basePath}/service-system-helper/${id}`),
  replaceHelper: (id, operatorId) => Client.put(`${Config.basePath}/service-system-helper/replace/${id}`, {
    operatorId,
  }),

  getServiceProduct: payload => Client.get(`${resource}/product`, {
    params: prepareSearchParams(payload),
  }),
  createServiceProduct: payload => Client.post(`${resource}/product`, payload),
  updateServiceProduct: (id, payload) => Client.put(`${resource}/product/${id}`, payload),
  deleteServiceProduct: id => Client.delete(`${resource}/product/${id}`),
  getChatChannel: payload => Client.post(`${resource}/chat-channel`, payload),
  priceValidateLaundry: payload => Client.post(`${resource}/price-validate/laundry`, payload),
  priceValidateCleaning: payload => Client.post(`${resource}/price-validate/cleaning`, payload),
  priceValidateMaintenance: payload => Client.post(`${resource}/price-validate/maintenance`, payload),
  priceValidateWaterDelivery: payload => Client.post(`${resource}/price-validate/water-delivery`, payload),
}
